import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealPriorityRequest, DealPriorityResponse, NewPageResponse } from '../models/deal-priority.model';

@Injectable({ providedIn: 'root' })
export class DealPriorityApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-priorities`;

  constructor(private http: HttpClient) {}

  getAll(businessId: number, page = 0, size = 20): Observable<NewPageResponse<DealPriorityResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId)
      .set('page', page)
      .set('size', size);
    return this.http.get<NewPageResponse<DealPriorityResponse>>(this.apiUrl, { params });
  }

  getById(id: number, businessId: number): Observable<DealPriorityResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.get<DealPriorityResponse>(`${this.apiUrl}/${id}`, { params });
  }

  create(req: DealPriorityRequest): Observable<DealPriorityResponse> {
    return this.http.post<DealPriorityResponse>(this.apiUrl, req);
  }

  update(id: number, req: DealPriorityRequest): Observable<DealPriorityResponse> {
    return this.http.put<DealPriorityResponse>(`${this.apiUrl}/${id}`, req);
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }
}
